import { useCallback } from "react";
import { showDailyLimitPaywall } from "@/hooks/usePaywallDialog";
import { useUsageGate } from "@/hooks/useUsageGate";
import { decideExport, decideExportKeyed } from "@/lib/exportGate";

/**
 * For a Premium tool's export button (CSV, Excel, PDF, image, ICS, backup...). Call `await checkExport()` first and
 * stop when it returns false: the paywall dialog is then already open and no file must be made. It takes no use;
 * the use is taken by downloadBlob when the file is really saved (lib/exportGate.ts).
 */
export function useExportGate() {
  const { known, paid, toolId, scope, fetcher } = useUsageGate();
  // `key` (lib/exportCharge exportKey): for tools where the person edits and delivers again in one visit; the same
  // unchanged output is free, a changed one needs a use.
  const checkExport = useCallback(async (key?: string): Promise<boolean> => {
    if (!known || paid) return true;
    const d = key ? await decideExportKeyed(toolId, scope, key, fetcher) : await decideExport(toolId, scope, fetcher);
    if (d === "blocked") {
      showDailyLimitPaywall(toolId, "download");
      return false;
    }
    return true;
  }, [known, paid, toolId, scope, fetcher]);
  return { checkExport };
}
